import { render } from "./BugReportView.vue?vue&type=template&id=7e3aaba8&scoped=true"
import script from "./BugReportView.vue?vue&type=script&lang=js"
export * from "./BugReportView.vue?vue&type=script&lang=js"

import "./BugReportView.vue?vue&type=style&index=0&id=7e3aaba8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3aaba8"]])

export default __exports__